'use strict';

import * as _ from 'lodash';

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');
  $locationProvider.html5Mode(true);
}

export function responseCodeInterceptor($httpProvider) {
  'ngInject';
  $httpProvider.interceptors.push('authInterceptor');
}

export function lightBoxConfig(LightboxProvider) {
  'ngInject';
  LightboxProvider.getImageUrl = image => '/images/' + image.getName();
}

export function stateConfigChanged($rootScope, $cookies, authService) {
  'ngInject';
  const escasePages = [
    'swaggerOAuthDone',
    'login',
    'logout'
  ];

  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      if(window.location.pathname.indexOf('/documentation') >= 0) {
        window.jQuery([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 500);
      }        

      setTimeout(() => {
        if(authService.isLoggedIn()) {
          if(escasePages.find(x => window.location.pathname.indexOf(`/${x}`) >= 0)) {
            return;
          }          

          const expires = new Date();
          expires.setDate(expires.getDate() + 30);
          $cookies.put('home-uri', window.location.pathname, { expires: expires });  
        }        
      }, 500);
  });
}



// WEBPACK FOOTER //
// ./client/app/app.config.js